module.exports = __webpack_public_path__ + "static/media/new-york-71.e90510d3.jpg";